module.exports = __webpack_public_path__ + "static/media/brain.c98edce6.svg";